import { getStoreData, Log } from "utils";
import { getUuid } from "./../../utils/utils";
import { Alert } from "components";
import { apiAuth } from "services/api";
import I18n from "languages/i18n";

export const doUploadFileSignature = async (p: {
  link: string;
  I18nState: "en" | "vi";
  onFinish: (otpInfo: any, phone: any) => void;
}) => {
  try {
    const bb = await fetch(p.link);
    const blob = await bb.blob();
    const id = getUuid();
    const formdata = new FormData();
    const file = new File([blob], `${id}.png`);
    formdata.append("file", file);
    const res = await apiAuth.createEsignature(formdata);
    const phone = await getStoreData("phone");

    if (res?.status == 200 && !!res?.data?.otpInfo) {
      if (p?.onFinish) {
        p?.onFinish(res?.data?.otpInfo, phone);
      }
    } else {
      const msg = I18n.t("alert.daxayraloi");
      Alert.showError({
        content:
          p.I18nState == "vi" ? res?.message || msg : res?.messageEn || msg,
        multilanguage: false,
      });
    }
  } catch (error: any) {
    Alert.showError({
      content: p.I18nState == "vi" ? error.message : error.messageEn,
      multilanguage: false,
    });
  }
};
